
export default function Tools() {
  const tools = [
    { name: 'Photoshop', icon: 'ri-brush-4-line', gradient: 'from-blue-600 to-cyan-600' },
    { name: 'Canva', icon: 'ri-palette-line', gradient: 'from-purple-600 to-pink-600' },
  ];

  return (
    <section className="relative py-24 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold mb-4 bg-gradient-to-r from-white via-purple-200 to-pink-200 bg-clip-text text-transparent">
            Tools I Use
          </h2>
        </div>

        {/* Tools Grid */}
        <div className="flex justify-center gap-8 flex-wrap">
          {tools.map((tool, index) => (
            <div
              key={index}
              className="group relative w-32 h-32 cursor-pointer"
            >
              {/* Glow effect */}
              <div className={`absolute inset-0 bg-gradient-to-r ${tool.gradient} opacity-30 group-hover:opacity-50 rounded-3xl blur-xl transition-opacity duration-500`}></div>
              
              {/* Tool Card */}
              <div className={`relative w-full h-full bg-gradient-to-br ${tool.gradient} rounded-3xl flex flex-col items-center justify-center shadow-lg group-hover:shadow-2xl transition-all duration-300 group-hover:scale-110`}>
                <i className={`${tool.icon} text-5xl mb-2`}></i>
                <span className="text-sm font-semibold">{tool.name}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
